import { takeLatest, put, all, call } from 'redux-saga/effects';
import { goBack } from 'connected-react-router';
import { divisionsAPI } from 'resources/api';
import { usersAPI } from 'resources/api';
import Types from './types';
import { processError } from 'state/utils';

function* fetchStartAsync({ payload }) {
  try {
    const res = yield divisionsAPI.getAll(payload);
    yield put({ type: Types.FETCH_SUCCESS, payload: res });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.FETCH_ERROR, payload: message });
  }
}

function* fetchStart() {
  yield takeLatest(Types.FETCH_START, fetchStartAsync);
}

function* fetchOneStartAsync({ payload }) {
  try {
    const res = yield divisionsAPI.getOne(payload);
    yield put({ type: Types.FETCH_ONE_SUCCESS, payload: res });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.FETCH_ERROR, payload: message });
  }
}

function* fetchOneStart() {
  yield takeLatest(Types.FETCH_ONE_START, fetchOneStartAsync);
}

function* updateStartAsync({ payload }) {
  try {
    const { item, goBack: shouldGoBack } = payload;
    yield divisionsAPI.update(item);
    yield put({ type: Types.UPDATE_SUCCESS, payload: item });
    yield put({ type: Types.FETCH_START, payload: item.groupId ?? '' });
    if (shouldGoBack) yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.UPDATE_ERROR, payload: message });
  }
}

function* updateStart() {
  yield takeLatest(Types.UPDATE_START, updateStartAsync);
}

function* createStartAsync({ payload }) {
  try {
    yield divisionsAPI.create(payload);
    yield put({ type: Types.CREATE_SUCCESS, payload });
    yield put({ type: Types.FETCH_START });
    yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.CREATE_ERROR, payload: message });
  }
}

function* createStart() {
  yield takeLatest(Types.CREATE_START, createStartAsync);
}

function* createStartBulkAsync({ payload }) {
  try {
    for (const division of payload) {
      yield divisionsAPI.create(division);
    }
    yield put({ type: Types.CREATE_SUCCESS });
    yield put({ type: Types.FETCH_START });
    yield put(goBack());
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.CREATE_ERROR, payload: message });
  }
}

function* createStartBulk() {
  yield takeLatest(Types.CREATE_START_BULK, createStartBulkAsync);
}

function* deleteStartAsync({ payload }) {
  try {
    yield divisionsAPI.delete(payload);
    yield put({ type: Types.DELETE_SUCCESS, payload });
  } catch (error) {
    const message = processError(error);
    console.error(message);
    yield put({ type: Types.DELETE_ERROR, payload: message });
  }
}

function* deleteStart() {
  yield takeLatest(Types.DELETE_START, deleteStartAsync);
}

export default function* sagas() {
  yield all([
    call(fetchStart),
    call(fetchOneStart),
    call(updateStart),
    call(createStart),
    call(deleteStart),
    call(createStartBulk),
  ]);
}
